import { useEffect } from 'react';
import _reactGA4 from 'react-ga4';
import {
  ANALYTICS_DEBUGMODE,
  ANALYTICS_ENABLED,
  ANALYTICS_TESTMODE,
  ANALYTICS_TRACKINGID,
} from '../utils/analytics';

// Handles CJS/ESM interop: Rolldown production bundler may double-wrap the default export
const reactGA4 = _reactGA4?.default ?? _reactGA4;

const options = {
  testMode: ANALYTICS_TESTMODE,
  gaOptions: {
    debug_mode: ANALYTICS_DEBUGMODE,
  },
};

export const useAnalyticsInitialize = () => {
  useEffect(() => {
    if (!ANALYTICS_ENABLED || !ANALYTICS_TRACKINGID) {
      return;
    }

    reactGA4.initialize(ANALYTICS_TRACKINGID, options);
  }, []);
};
